module.exports = __webpack_public_path__ + "29d36f8888a12d0fba4417f6e15e6295.png";